/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-06.
 * Actions for the container.
 */
import {
    NOTIFY,
    FETCH_DATA,
    FETCH_COMPLETE
} from './types';
import { users } from '../../services';

const services = { users };

export const fetchData = (service, path, url, params = {}) => {
    return (dispatch) => {
        dispatch({ type: FETCH_DATA });
        return services[service].get(url, params).then(result => {
            if(typeof(result.response) === "undefined"){
              onDataLoaded(dispatch, path, result._embedded.users);
            }else {
              showErrorMessage(dispatch, result.response.data.message)
            }
        });
    };
};

export const fetchloggedUser = (path, userId, params = {}) => {
    var url = 'users?id=' + userId + '&projection=usersProjection';
    return (dispatch) => {
        dispatch({ type: FETCH_DATA });
        return services['users'].get(url, params).then(result => {
            if(typeof(result.response) === "undefined"){
              onDataLoaded(dispatch, path, result._embedded.users);
            }else {
              showErrorMessage(dispatch, result.response.data.message)
            }
        });
    };
};

const onDataLoaded = (dispatch, path, value) => {
    dispatch({
        type: FETCH_COMPLETE,
        payload: { op: 'update', path, value }
    });
    return value;
};

const showErrorMessage = (dispatch, message)  => {
  onDataLoaded(dispatch,'notificationColor', "red");
  onDataLoaded(dispatch,'showMessage', message);
  onDataLoaded(dispatch,'showNotification', true);
};

export const saveUser = (newUser) => {

    newUser = {
        name: newUser.name,
        email: newUser.email,
        role: newUser.role,
        active: true,
        password: '',
        roster: ''
    }

    return (dispatch) => {
        dispatch({ type: FETCH_DATA });
        return services["users"].post("overwrite/user", newUser).then(result => {
            if(typeof(result.response) === "undefined"){
              //Cierro modal de formulario
              dispatch({ type: FETCH_COMPLETE, payload: { op: 'update', path: 'formOpen', value: false } });
              //Añado una nueva aduana a la lista del estado
              dispatch({ type: FETCH_COMPLETE, payload: { op: 'add', path: 'users', value: result } });
            }else {
              dispatch({ type: FETCH_COMPLETE, payload: { op: 'update', path: 'formOpen', value: false } });
              showErrorMessage(dispatch, result.response.data.message)
            }
        });
    };
};

export const editUser = (newUser, index) => {

    var userModified = {
        active: newUser.active,
        email: newUser.email,
        name: newUser.name,
        roster: newUser.roster,
        password: newUser.password,
        role: newUser.role,
        id: newUser.id.replace('/user/', '')
    }

    return (dispatch) => {
        dispatch({ type: FETCH_DATA });
        return services["users"].put("overwrite/user/", userModified).then(result => {
            if(typeof(result.response) === "undefined"){
              //Cierro modal de formulario
              dispatch({ type: FETCH_COMPLETE, payload: { op: 'update', path: 'formOpen', value: false } });
              //Añado una nueva aduana a la lista del estado
              dispatch({ type: FETCH_COMPLETE, payload: { op: 'updateItem', path: 'users', value: { index, value: { ...result, id: userModified.id } } } });
            }else {
              showErrorMessage(dispatch, result.response.data.message)
            }
        });
    };
};

export const editUserPasswordRoster = (newUser) => {

    if (newUser.newPassword != "") {
        newUser = {
            id: newUser.user.id.replace("/user/", ""),
            password: newUser.newPassword,
            roster: newUser.user.roster,
            name: newUser.user.name,
            email: newUser.user.email,
            role: newUser.user.role,
            active: newUser.user.active,
            changed: true
        }
    } else {
        newUser = {
            id: newUser.user.id.replace("/user/", ""),
            password: newUser.user.password,
            roster: newUser.user.roster,
            name: newUser.user.name,
            email: newUser.user.email,
            role: newUser.user.role,
            active: newUser.user.active,
            changed: false
        }
    }


    return (dispatch) => {
        return services["users"].put("overwrite/user/", newUser).then(result => { });
    };
};

export const notify = (payload) => {
    return {
        type: NOTIFY,
        payload
    };
};



// WEBPACK FOOTER //
// ./containers/users/actions.js